export enum CookieConsentActionTypes {
  SET_CONSENT = 'SET_CONSENT',
  RESET_CONSENT = 'RESET_CONSENT',
}

export type ConsentType = 'all' | 'essential' | null;

export const setConsent = (consentType: ConsentType) => ({
  type: CookieConsentActionTypes.SET_CONSENT as const,
  payload: { consentType },
});

export const resetConsent = () => ({
  type: CookieConsentActionTypes.RESET_CONSENT as const,
});

export type SetConsentAction = ReturnType<typeof setConsent>;
export type ResetConsentAction = ReturnType<typeof resetConsent>;

export type CookieConsentActions = SetConsentAction | ResetConsentAction;

export default { setConsent, resetConsent };
